/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IDobbiesBrandViewProps } from './dobbies-brand';
// import { convertToString } from '@msdyn365-commerce/retail-proxy';
import Button from 'reactstrap/lib/Button';
import MsDyn365, * as Msdyn365 from '@msdyn365-commerce/core';
import { IBrandProductsImagesUrlsData } from './dobbies-brand.props.autogenerated';

// const decodeHtmlCharCodes = (str: string) => {
//     return str.replace(/(&#(\d+);)/g, function(match, capture, charCode) {
//         return String.fromCharCode(charCode);
//     });
// };
export interface IDobbiesBrandsDisplayInformation {
    brandLink?: string;
    brandLogo?: string;
    brandProductsImageInfo?: IBrandProductsImagesUrlsData[];
    brandsDescription?: string;
    brandName?: string;
    brandStartingAlphabet?: string;
}

export interface IDobbiesAllAlphabetsView {
    brandsView: IDobbiesBrandsDisplayInformation[][];
    alphabet: string;
}
export default (props: IDobbiesBrandViewProps) => {
    // const htmlTotext = decodeHtmlCharCodes(convertToString(props.config.brands)).replace(/&amp;/g, '&');
    // const brands = htmlTotext.split(',');
    // const id = props.config.categoryID ? props.config.categoryID : 5637242076;
    const [selectedAlphabet, setSelectedAlphabet] = React.useState('');
    const alphabetsList = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        '#'
    ];

    const _getScreenSize = (ctx: Msdyn365.ICoreContext): number => {
        // always render in mobile viewport on a mobile device
        // if (ctx.request && ctx.request.device && ctx.request.device.Type === 'Mobile') {
        //     return 1;
        // }

        if ((MsDyn365.isBrowser && window) !== undefined && MsDyn365.isBrowser && window && window.innerWidth) {
            const gridSettings = ctx.request.gridSettings;
            if (gridSettings) {
                if (gridSettings.xs && (MsDyn365.isBrowser && window && window.innerWidth) < gridSettings.xs.w) {
                    // mobile
                    return 1;
                } else if (gridSettings.sm && (MsDyn365.isBrowser && window && window.innerWidth) <= gridSettings.sm.w) {
                    // iPad
                    return 2;
                } else if (gridSettings.md && (MsDyn365.isBrowser && window && window.innerWidth) <= gridSettings.md.w) {
                    // Desktop
                    return 3;
                } else if (gridSettings.lg && (MsDyn365.isBrowser && window && window.innerWidth) <= gridSettings.lg.w) {
                    // Desktop
                    return 3;
                } else {
                    return 3;
                }
            }
        }

        return 3; // desktop
    };
    // const brandsView: IDobbiesBrandsDisplayInformation[][] = [];
    const allAlphabetsBrandsView: IDobbiesAllAlphabetsView[] = [];
    const screenSize = _getScreenSize(props.context);
    const maxBrandsPerColumn = screenSize === 3 ? 4 : 7;
    const columnClassname = screenSize === 3 ? 'col-3' : 'col-6';
    let currentColumn = 0;
    const startsWithNumber = (str: string): boolean => {
        return /^\d/.test(str);
    };

    for (const apbt of alphabetsList) {
        const alphabetBrandsView: IDobbiesBrandsDisplayInformation[][] = [];
        props.alphabeticallySortedBrands?.map((sortedItem, index: number) => {
            if (apbt === '#' && startsWithNumber(sortedItem.alphabet)) {
                currentColumn = 0;
                sortedItem.brands.map(item => {
                    if (alphabetBrandsView.length < currentColumn + 1) {
                        alphabetBrandsView.push([]);
                    }
                    if (alphabetBrandsView[currentColumn] && alphabetBrandsView[currentColumn].length >= maxBrandsPerColumn) {
                        alphabetBrandsView.push([]);
                        if (alphabetBrandsView[currentColumn].length > 0) {
                            currentColumn = currentColumn + 1;
                        }
                    }
                    const brandlink = item.Url;
                    const brandLogoUrl: string | undefined = props.config.brandsDetails?.find(detail => detail.brandName === item.Name)
                        ?.brandLogoUrl;
                    const brandProductsInfo = props.config.brandsDetails?.find(detail => detail.brandName === item.Name)
                        ?.brandProductsImagesUrls;
                    const brandsDescription = props.config.brandsDetails?.find(detail => detail.brandName === item.Name)?.brandDescription;
                    const brandInfo: IDobbiesBrandsDisplayInformation = {
                        brandLink: brandlink,
                        brandLogo: brandLogoUrl,
                        brandProductsImageInfo: brandProductsInfo,
                        brandsDescription: brandsDescription,
                        brandName: item.Name,
                        brandStartingAlphabet: sortedItem.alphabet
                    };
                    if (alphabetBrandsView[currentColumn]) {
                        alphabetBrandsView[currentColumn].push(brandInfo);
                    }
                    // else if (alphabetBrandsView[currentColumn - 1] && !alphabetBrandsView[currentColumn - 1].length) {
                    //     alphabetBrandsView[currentColumn - 1].push(brandInfo);
                    // } else if (alphabetBrandsView[currentColumn - 2] && !alphabetBrandsView[currentColumn - 2].length) {
                    //     alphabetBrandsView[currentColumn - 2].push(brandInfo);
                    // }
                    // else {
                    //     alphabetBrandsView[currentColumn] = [];
                    // }
                });
            } else if (sortedItem.alphabet === apbt) {
                currentColumn = 0;
                sortedItem.brands.map(item => {
                    if (alphabetBrandsView.length < currentColumn + 1) {
                        alphabetBrandsView.push([]);
                    }
                    if (alphabetBrandsView[currentColumn] && alphabetBrandsView[currentColumn].length >= maxBrandsPerColumn) {
                        alphabetBrandsView.push([]);
                        if (alphabetBrandsView[currentColumn].length > 0) {
                            currentColumn = currentColumn + 1;
                        }
                    }
                    const brandlink = item.Url;
                    const brandLogoUrl: string | undefined = props.config.brandsDetails?.find(detail => detail.brandName === item.Name)
                        ?.brandLogoUrl;
                    const brandProductsInfo = props.config.brandsDetails?.find(detail => detail.brandName === item.Name)
                        ?.brandProductsImagesUrls;
                    const brandsDescription = props.config.brandsDetails?.find(detail => detail.brandName === item.Name)?.brandDescription;
                    const brandInfo: IDobbiesBrandsDisplayInformation = {
                        brandLink: brandlink,
                        brandLogo: brandLogoUrl,
                        brandProductsImageInfo: brandProductsInfo,
                        brandsDescription: brandsDescription,
                        brandName: item.Name,
                        brandStartingAlphabet: sortedItem.alphabet
                    };
                    if (alphabetBrandsView[currentColumn]) {
                        alphabetBrandsView[currentColumn].push(brandInfo);
                    }
                    // else if (alphabetBrandsView[currentColumn - 1] && !alphabetBrandsView[currentColumn - 1].length) {
                    //     alphabetBrandsView[currentColumn - 1].push(brandInfo);
                    // } else if (alphabetBrandsView[currentColumn - 2] && !alphabetBrandsView[currentColumn - 2].length) {
                    //     alphabetBrandsView[currentColumn - 2].push(brandInfo);
                    // }
                    //  else {
                    //     alphabetBrandsView[currentColumn] = [];
                    // }
                });
            }
        });

        allAlphabetsBrandsView.push({ alphabet: apbt, brandsView: alphabetBrandsView });
    }

    console.log('All alphabets brands view', allAlphabetsBrandsView);

    // if (props.alphabeticallySortedBrands) {
    //     if (selectedAlphabet === '') {
    //         for (const apbt of alphabetsList) {
    //             props.alphabeticallySortedBrands?.map((sortedItem, index: number) => {
    //                 if (sortedItem.alphabet === apbt) {
    //                     sortedItem.brands.map(item => {
    //                         if (brandsView.length < currentColumn + 1) {
    //                             brandsView.push([]);
    //                         }
    //                         if (brandsView[currentColumn].length >= maxBrandsPerColumn) {
    //                             brandsView.push([]);
    //                             currentColumn = currentColumn + 1;
    //                         }
    //                         const brandlink = item.Url;
    //                         const brandLogoUrl: string | undefined = props.config.brandsDetails?.find(
    //                             detail => detail.brandName === item.Name
    //                         )?.brandLogoUrl;
    //                         const brandProductsInfo = props.config.brandsDetails?.find(detail => detail.brandName === item.Name)
    //                             ?.brandProductsImagesUrls;
    //                         const brandsDescription = props.config.brandsDetails?.find(detail => detail.brandName === item.Name)
    //                             ?.brandDescription;
    //                         const brandInfo: IDobbiesBrandsDisplayInformation = {
    //                             brandLink: brandlink,
    //                             brandLogo: brandLogoUrl,
    //                             brandProductsImageInfo: brandProductsInfo,
    //                             brandsDescription: brandsDescription,
    //                             brandName: item.Name,
    //                             brandStartingAlphabet: sortedItem.alphabet
    //                         };
    //                         brandsView[currentColumn].push(brandInfo);
    //                     });
    //                 }
    //             });
    //         }
    //     } else {
    //         props.alphabeticallySortedBrands?.map((sortedItem, index: number) => {
    //             if (sortedItem.brands && sortedItem.brands.length && selectedAlphabet === '#') {
    //                 sortedItem.brands.map(item => {
    //                     if (item.Name && !startsWithNumber(item.Name)) {
    //                         return;
    //                     }
    //                     if (brandsView.length < currentColumn + 1) {
    //                         brandsView.push([]);
    //                     }
    //                     if (brandsView[currentColumn].length >= maxBrandsPerColumn) {
    //                         brandsView.push([]);
    //                         currentColumn = currentColumn + 1;
    //                     }
    //                     const brandlink = item.Url;
    //                     const brandLogoUrl: string | undefined = props.config.brandsDetails?.find(detail => detail.brandName === item.Name)
    //                         ?.brandLogoUrl;
    //                     const brandProductsInfo = props.config.brandsDetails?.find(detail => detail.brandName === item.Name)
    //                         ?.brandProductsImagesUrls;
    //                     const brandsDescription = props.config.brandsDetails?.find(detail => detail.brandName === item.Name)
    //                         ?.brandDescription;
    //                     const brandInfo: IDobbiesBrandsDisplayInformation = {
    //                         brandLink: brandlink,
    //                         brandLogo: brandLogoUrl,
    //                         brandProductsImageInfo: brandProductsInfo,
    //                         brandsDescription: brandsDescription,
    //                         brandName: item.Name,
    //                         brandStartingAlphabet: sortedItem.alphabet
    //                     };
    //                     brandsView[currentColumn].push(brandInfo);
    //                 });
    //             } else if (
    //                 !sortedItem.brands ||
    //                 !sortedItem.brands.length ||
    //                 sortedItem.alphabet.toLowerCase() !== selectedAlphabet.toLowerCase()
    //             ) {
    //                 return;
    //             } else if (
    //                 sortedItem.brands &&
    //                 sortedItem.brands.length &&
    //                 sortedItem.alphabet.toLowerCase() === selectedAlphabet.toLowerCase()
    //             ) {
    //                 sortedItem.brands.map(item => {
    //                     if (brandsView.length < currentColumn + 1) {
    //                         brandsView.push([]);
    //                     }
    //                     if (brandsView[currentColumn].length >= maxBrandsPerColumn) {
    //                         brandsView.push([]);
    //                         currentColumn = currentColumn + 1;
    //                     }
    //                     const brandlink = item.Url;
    //                     const brandLogoUrl: string | undefined = props.config.brandsDetails?.find(detail => detail.brandName === item.Name)
    //                         ?.brandLogoUrl;
    //                     const brandProductsInfo = props.config.brandsDetails?.find(detail => detail.brandName === item.Name)
    //                         ?.brandProductsImagesUrls;
    //                     const brandsDescription = props.config.brandsDetails?.find(detail => detail.brandName === item.Name)
    //                         ?.brandDescription;
    //                     const brandInfo: IDobbiesBrandsDisplayInformation = {
    //                         brandLink: brandlink,
    //                         brandLogo: brandLogoUrl,
    //                         brandProductsImageInfo: brandProductsInfo,
    //                         brandsDescription: brandsDescription,
    //                         brandName: item.Name,
    //                         brandStartingAlphabet: sortedItem.alphabet
    //                     };
    //                     brandsView[currentColumn].push(brandInfo);
    //                 });
    //             }
    //         });
    //     }
    // }
    React.useEffect(() => {
        resetUI();
    }, [selectedAlphabet]);
    React.useEffect(() => {
        setTimeout(() => {
            const brandSelected = document.getElementById(`brand-select-${selectedAlphabet}`);
            brandSelected?.classList.add('brand-selected');
        }, 2000);
    }, []);
    const resetUI = () => {
        const selectedClassname = `brand-selected`;
        for (const alphabet of alphabetsList) {
            if (alphabet !== selectedAlphabet) {
                const alphabetID = `brand-select-${alphabet}`;
                const alphabetElement = document.getElementById(alphabetID);
                alphabetElement?.classList.remove(selectedClassname);
            }
        }
        // brandsView.map((brandInfoRow, i: number) => {
        //     brandInfoRow.map((column, index: number) => {
        //         const dropdownElem = document.getElementById(`brand-id-${column.brandName?.toLowerCase()}`);
        //         const dropDownBtn = document.getElementsByClassName('brands-dropdown-btn')[0];
        //         dropdownElem?.classList.remove('show-brands-dropdown');
        //         dropDownBtn?.classList.remove('showdropdown');
        //         if (!dropdownElem?.classList.contains('hide-brands-dropdown')) {
        //             dropdownElem?.classList.add('hide-brands-dropdown');
        //         }
        //     });
        // });
    };

    const maxProductImages = 1; //screenSize === 1 ? 2 : 3;

    return (
        <div className={`brands-container ${props.config.showBrandsWithSEOFriendlyUrls ? 'new-brands-ui' : ''}`}>
            <h1>Shop by brand</h1>
            <ul className='Brands_brands--header-filters__lspAk'>
                {alphabetsList.map((alphabet, index) => {
                    return (
                        <li
                            id={`brand-select-${alphabet}`}
                            className='brand-alphabit'
                            key={index}
                            onClick={() => {
                                setSelectedAlphabet(alphabet);
                                const brandSelected = document.getElementById(`brand-select-${alphabet}`);
                                brandSelected?.classList.add('brand-selected');
                            }}
                        >
                            <a href='javascript:void(0)'>{alphabet}</a>
                        </li>
                    );
                })}
            </ul>
            <div className='see-all-brands-btn'>
                <a
                    className='see-all-brands'
                    href='javascript:void(0)'
                    onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                        setSelectedAlphabet('');
                        resetUI();
                    }}
                >
                    See all brands
                </a>
            </div>
            {allAlphabetsBrandsView.length ? (
                <div className='Brands_brands--section__1MCLm'>
                    <div
                        className={
                            selectedAlphabet === ''
                                ? 'Brands_brands--section-letters__2hvMX'
                                : 'Brands_brands--section-letters__2hvMX alphabet-selected'
                        }
                    >
                        {/* <div className='row'> */}
                        <>
                            {allAlphabetsBrandsView.map((alphabetView, iter) => {
                                const brandsView = alphabetView.brandsView;
                                if (
                                    (!brandsView.length || (brandsView.length && !brandsView[0].length)) &&
                                    selectedAlphabet !== '' &&
                                    alphabetView.alphabet === selectedAlphabet
                                ) {
                                    return (
                                        <div className='row' key={iter}>
                                            <div className='py-5 text-center' key={iter}>
                                                <h3>{props.config.noBrandMessage ? props.config.noBrandMessage : 'No Brands Found'}</h3>
                                            </div>
                                        </div>
                                    );
                                } else if (!brandsView.length || (brandsView.length && !brandsView[0].length)) {
                                    return <></>;
                                }
                                return (
                                    <>
                                        <div
                                            key={iter}
                                            style={{
                                                display:
                                                    selectedAlphabet === '' || alphabetView.alphabet === selectedAlphabet ? 'block' : 'none'
                                            }}
                                        >
                                            <p className='brand-block-header'>{alphabetView.alphabet}</p>
                                            {/* <div className='row'>
                                                <div className='col-12 brand-block-inner'>

                                                </div>
                                            </div> */}
                                            <div className='row brand-block-inner'>
                                                {brandsView.map((brandInfoRow, i: number) => {
                                                    return (
                                                        <div className={` brand-block ${columnClassname}`} key={i}>
                                                            {brandInfoRow.map((column, index: number) => {
                                                                return (
                                                                    <div className='brand-content' key={i + index}>
                                                                        <p key={i + index}>
                                                                            <a title={column.brandName} href={column.brandLink}>
                                                                                {column.brandName}
                                                                            </a>
                                                                            <Button
                                                                                id={`${column.brandName}-dropdown-btn`}
                                                                                onClick={() => {
                                                                                    const toggle = document.getElementById(
                                                                                        `${column.brandName}-dropdown-btn`
                                                                                    );
                                                                                    const dropdownElem = document.getElementById(
                                                                                        `brand-id-${column.brandName?.toLowerCase()}`
                                                                                    );

                                                                                    if (
                                                                                        dropdownElem?.classList.contains(
                                                                                            'hide-brands-dropdown'
                                                                                        )
                                                                                    ) {
                                                                                        dropdownElem?.classList.remove(
                                                                                            'hide-brands-dropdown'
                                                                                        );
                                                                                        dropdownElem?.classList.add('show-brands-dropdown');
                                                                                        toggle?.classList.add('showdropdown');
                                                                                    } else {
                                                                                        dropdownElem?.classList.remove(
                                                                                            'show-brands-dropdown'
                                                                                        );
                                                                                        dropdownElem?.classList.add('hide-brands-dropdown');
                                                                                        toggle?.classList.remove('showdropdown');
                                                                                    }
                                                                                }}
                                                                                className='brands-dropdown-btn '
                                                                            ></Button>
                                                                        </p>
                                                                        <div
                                                                            id={`brand-id-${column.brandName?.toLowerCase()}`}
                                                                            className='brands-detail-dropdown hide-brands-dropdown'
                                                                        >
                                                                            {column.brandLogo && (
                                                                                <div className='brand-logo'>
                                                                                    <img
                                                                                        className='brand-logo-img'
                                                                                        src={column.brandLogo}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            {column.brandProductsImageInfo && (
                                                                                <div className='brand-products'>
                                                                                    {column.brandProductsImageInfo
                                                                                        .slice(0, maxProductImages)
                                                                                        .map((imgInfo, index) => {
                                                                                            return (
                                                                                                <a href={imgInfo.imageLink} key={index}>
                                                                                                    <img
                                                                                                        className='brand-products-img'
                                                                                                        src={imgInfo.imageUrl}
                                                                                                    />
                                                                                                </a>
                                                                                            );
                                                                                        })}
                                                                                </div>
                                                                            )}

                                                                            {column.brandsDescription && (
                                                                                <p className='brand-description'>
                                                                                    {column.brandsDescription}
                                                                                </p>
                                                                            )}

                                                                            <a className='brand-link' href={column.brandLink}>
                                                                                Find out more
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                            {/* {props.alphabeticallySortedBrands &&
                                    props.alphabeticallySortedBrands?.map((sortedItem, index: number) => {
                                        if (
                                            !sortedItem.brands ||
                                            !sortedItem.brands.length ||
                                            sortedItem.alphabet.toLowerCase() !== selectedAlphabet.toLowerCase()
                                        ) {
                                            return <></>;
                                        }
                                        return (
                                            <div key={index}>
                                                <div className='Brands_brands--section-letter__IH1kG' key={index}>
                                                    <p id={sortedItem.alphabet} className='Brands_brands--section-heading__3WoWd'>
                                                    {sortedItem.alphabet}
                                                </p>
                                                    {props.alphabeticallySortedBrands &&
                                                        sortedItem.brands.map((item, i: number) => {
                                                            const brandlink = item.Url;
                                                            const brandLogoUrl = props.config.brandsDetails?.find(
                                                                detail => detail.brandName === item.Name
                                                            )?.brandLogoUrl;
                                                            const brandProductsImageUrl = props.config.brandsDetails?.find(
                                                                detail => detail.brandName === item.Name
                                                            )?.brandProductsImageUrl;
                                                            const brandsDescription = props.config.brandsDetails?.find(
                                                                detail => detail.brandName === item.Name
                                                            )?.brandDescription;
                                                            return (
                                                                <div key={i + index}>
                                                                    <p key={i + index}>
                                                                        <a title={item.Name} href={brandlink}>
                                                                            {item.Name}
                                                                        </a>
                                                                        <Button
                                                                            onClick={() => {
                                                                                const toggle = document.getElementsByClassName(
                                                                                    'brands-dropdown-btn'
                                                                                )[0];

                                                                                //     toggle.classList.toggle('grow');

                                                                                const dropdownElem = document.getElementById(
                                                                                    `brand-id-${item.Name?.toLowerCase()}`
                                                                                );

                                                                                if (dropdownElem?.classList.contains('hide-brands-dropdown')) {
                                                                                    dropdownElem?.classList.remove('hide-brands-dropdown');
                                                                                    dropdownElem?.classList.add('show-brands-dropdown');
                                                                                    toggle?.classList.add('showdropdown');
                                                                                } else {
                                                                                    dropdownElem?.classList.remove('show-brands-dropdown');
                                                                                    dropdownElem?.classList.add('hide-brands-dropdown');
                                                                                    toggle?.classList.remove('showdropdown');
                                                                                }
                                                                            }}
                                                                            className='brands-dropdown-btn '
                                                                        ></Button>
                                                                    </p>
                                                                    <div
                                                                        id={`brand-id-${item.Name?.toLowerCase()}`}
                                                                        className='brands-detail-dropdown hide-brands-dropdown'
                                                                    >
                                                                        {brandLogoUrl && <img className='brand-logo' src={brandLogoUrl} />}
                                                                        {brandProductsImageUrl && (
                                                                            <img className='brand-products' src={brandProductsImageUrl} />
                                                                        )}

                                                                        {brandsDescription && (
                                                                            <p className='brand-description'>{brandsDescription}</p>
                                                                        )}

                                                                        <a className='brand-link' href={brandlink}>
                                                                            Find out more
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                        );
                                    })} */}
                            {/* {!props.alphabeticallySortedBrands && (
                                    <>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='A' className='Brands_brands--section-heading__3WoWd'>
                                                A
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'A') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='B' className='Brands_brands--section-heading__3WoWd'>
                                                B
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'B') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='C' className='Brands_brands--section-heading__3WoWd'>
                                                C
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'C') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='D' className='Brands_brands--section-heading__3WoWd'>
                                                D
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'D') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='E' className='Brands_brands--section-heading__3WoWd'>
                                                E
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'E') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='F' className='Brands_brands--section-heading__3WoWd'>
                                                F
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'F') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='G' className='Brands_brands--section-heading__3WoWd'>
                                                G
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'G') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='H' className='Brands_brands--section-heading__3WoWd'>
                                                H
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'H') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='I' className='Brands_brands--section-heading__3WoWd'>
                                                I
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'I') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='J' className='Brands_brands--section-heading__3WoWd'>
                                                J
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'J') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='K' className='Brands_brands--section-heading__3WoWd'>
                                                K
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'K') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='L' className='Brands_brands--section-heading__3WoWd'>
                                                L
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'L') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='M' className='Brands_brands--section-heading__3WoWd'>
                                                M
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'M') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='N' className='Brands_brands--section-heading__3WoWd'>
                                                N
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'N') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='O' className='Brands_brands--section-heading__3WoWd'>
                                                O
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'O') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='P' className='Brands_brands--section-heading__3WoWd'>
                                                P
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'P') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='Q' className='Brands_brands--section-heading__3WoWd'>
                                                Q
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'Q') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='R' className='Brands_brands--section-heading__3WoWd'>
                                                R
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'R') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='S' className='Brands_brands--section-heading__3WoWd'>
                                                S
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'S') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='T' className='Brands_brands--section-heading__3WoWd'>
                                                T
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'T') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='U' className='Brands_brands--section-heading__3WoWd'>
                                                U
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'U') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='V' className='Brands_brands--section-heading__3WoWd'>
                                                V
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'V') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='W' className='Brands_brands--section-heading__3WoWd'>
                                                W
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'W') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='X' className='Brands_brands--section-heading__3WoWd'>
                                                X
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'X') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='Y' className='Brands_brands--section-heading__3WoWd'>
                                                Y
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'Y') {
                                                        return (
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className='Brands_brands--section-letter__IH1kG'>
                                            <p id='Z' className='Brands_brands--section-heading__3WoWd'>
                                                Z
                                            </p>
                                            <ul className='Brands_brands--section-values__112Uq'>
                                                {brands?.map((item, index: number) => {
                                                    const brandlink = `/all/${id}.c?refiners=%5B%5B5%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C5637147579%2C1%2C"${item
                                                        .trim()
                                                        .replace(/(<([^>]+)>)/gi, '')
                                                        .replace(/[+]/g, '%2B')
                                                        .replace(/&/g, '%26')
                                                        .replace(/\s/g, '+')}"%2C""%5D%5D`;
                                                    if (item.trim().charAt(0) === 'Z') {
                                                        return console.log(
                                                            'Z',
                                                            <li key={index}>
                                                                <a href={brandlink}>{item.trim().replace(/(<([^>]+)>)/gi, '')}</a>
                                                            </li>
                                                        );
                                                    } else {
                                                        return;
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                    </>
                                )} */}
                        </>
                        {/* </div> */}
                    </div>
                </div>
            ) : (
                <div className='py-5 text-center'>
                    <h3>{props.config.noBrandMessage ? props.config.noBrandMessage : 'No Brands Found'}</h3>
                </div>
            )}
        </div>
    );
};
